const getLabel = (sort: string[]) => {
  if (sort[0] === 'scoreDesc') {
    return `mais relevantes`;
  }
  if (sort[0] === 'createdAtDesc') {
    return 'mais recentes';
  }
  if (sort[0] === 'createdAtAsc') {
    return 'mais antigas';
  }
  if (sort[0] === 'ratingDesc') {
    return 'mais positivas';
  }
  if (sort[0] === 'ratingAsc') {
    return 'mais negativas';
  }

  return 'mais relevantes';
};

export default getLabel;
export { getLabel };
